<template>
  <suggest
    :suggestions="suggestions"
    :inputProps="inputProps"
    :getSuggestionValue="getSuggestionValue"
    :renderSuggestion="renderSuggestion"
    @selected="selectHandler"
    >
  </suggest>
</template>

<script>
import axios from 'axios'
import { VueAutosuggest } from 'vue-autosuggest'

export default {
  name: 'searchClients',
  components: { 'suggest': VueAutosuggest },
  data () {
    return {
      inputProps: {
        id: 'autosuggest__input',
        onInputChange: this.fetchResults,
        placeholder: 'Search for a contact'
      },
      suggestions: [],
      selected: null,
      timeout: null,
      debounceMilliseconds: 200
    }
  },
  methods: {
    fetchResults (str) {
      clearTimeout(this.timeout)
      if (!str || str.trim().length === 0) {
        return
      }
      this.timeout = setTimeout(() => {
        axios.get('/api/users/search/' + str).then(res => {
          if (res.status === 200) {
            this.suggestions = [{data: res.data}]
          }
        }).catch(e => { console.log(e.response.data) })
      }, this.debounceMilliseconds)
    },
    selectHandler (s) {
      this.selected = s
      this.$emit('selected', s.item)
    },
    renderSuggestion (s) {
      let p = s.item.profile
      if (p.corporate) {
        return p.business
      } else {
        return p.firstname + ' ' + p.lastname
      }
    },
    getSuggestionValue (s) {
      let p = s.item.profile
      if (p.corporate) {
        return p.business
      }
      return p.firstname + ' ' + p.lastname
    }
  }
}
</script>

<style>
#autosuggest__input {
  color: inherit;
  position: relative;
  display: block;
  height: 1.8rem;
  line-height: 1rem;
  padding: .35rem .4rem;
  width: 100%;
  border: .05rem solid #caced7;
  border-radius: .1rem;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  font-weight:100
}
#autosuggest__input.autosuggest__input-open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.autosuggest__results-container {
  position: relative;
  width: 100%;
}
.autosuggest__results {
  font-weight: 300;
  margin: 0;
  position: absolute;
  z-index: 10000001;
  width: 100%;
  border-left: .05rem solid #caced7;
  border-right: .05rem solid #caced7;
  border-bottom: .05rem solid #caced7;
  background: white;
  padding: 0px;
  max-height: 400px;
  overflow-y: scroll;
  border-radius: 0 0 .1rem .1rem;
}

.autosuggest__results ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.autosuggest__results ul li {
    margin: 0;
}

.autosuggest__results .autosuggest__results_item {
  cursor: pointer;
  padding: 15px;
  font-weight: 400;
  font-size: .7em;
}

#autosuggest ul:nth-child(1) > .autosuggest__results_title {
  border-top: none;
}

.autosuggest__results .autosuggest__results_title {
  color: gray;
  font-size: 11px;
  margin-left: 0;
  padding: 15px 13px 5px;
  border-top: 1px solid lightgray;
}

.autosuggest__results .autosuggest__results_item:active,
.autosuggest__results .autosuggest__results_item:focus,
.autosuggest__results
  .autosuggest__results_item.autosuggest__results_item-highlighted {
  background-color: #f6f6f6;
}

.autosuggest__results .autosuggest__results_item:hover {
  background-color: rgba(63, 169, 245, 0.15)!important;
  color:#136efb
}
</style>



// WEBPACK FOOTER //
// searchClients.vue?78412bdd